<template>
<v-dialog v-model="showRegister" persistent max-width="800px">
    <v-card style="border: 3px solid white !important; position: relative;">
        <v-btn fab x-small style="position: absolute; top: 0px; right: 0px; z-index: 5000;" @click="close">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-img :src="banner" width="100%"></v-img>
        <div style="margin-top: 15px; line-height: 1.2; text-align: center; font-weight: bold;">
            <span v-if="language=='fr-ca'">THROMBOSE DÉCORTIQUÉE : <br>DES DÉCISIONS QUI COMPTENT</span>
            <span v-else>Thrombosis Unpacked: <br>Decisions That Matter</span>
        </div>
        <div style="text-align: center; line-height: 1; margin: 10px 5px 0px 5px;">
            <sup>
                <span v-if="language=='fr-ca'">Conseils pratiques pour les décisions difficiles en matière de thrombose et d'anticoagulation dans la pratique clinique courante.</span>
                <span v-else>Practical guidance for difficult thrombosis and anticoagulation decisions in real-world clinical care.</span>
            </sup>
        </div>

        <v-card-text class="pa-5">
            <span v-if="language=='fr-ca'">Rejoignez des professionnels de la santé de partout au Canada à Montréal pour deux jours de formation pratique et multidisciplinaire axée sur les décisions complexes en matière de thrombose et d'anticoagulation rencontrées en pratique clinique.</span>
            <span v-else>Join healthcare professionals from across Canada in Montreal for two days of practical, multidisciplinary education focused on difficult thrombosis and anticoagulation decisions encountered in real-world clinical care.</span>
        </v-card-text>

        <v-card-text style="text-align: center;">
            <v-btn class="button-theme" dark @click="$router.push({path:'/hcp/education/cpd/tc_conference'}); close()">
                <span v-if="language=='fr-ca'">En savoir plus</span>
                <span v-else>Read more</span>
            </v-btn>
            <br><br>
            <v-btn class="button-theme red" dark href="https://thrombosiscanada.regfox.com/2026-canvector-thrombosis-canada-conference?_gl=1*177u94f*_gcl_au*MTkxNzQ5MDcyNi4xNzg2MTI3MTU4*_ga*NDE1ODc2NDM0LjE3NDg0NjQ3OTM.*_ga_TVXR7PZK59*czE3ODcwNzE0MjYkbzIzJGcxJHQxNzg3MDczMTY0JGoyOCRsMCRoMA.." target="_blank">
                <span v-if="language=='fr-ca'">Inscrivez-vous ici</span>
                <span v-else>Register Today</span>
            </v-btn>
        </v-card-text>
        <v-card-actions>
        <v-btn color="blue darken-1" text @click="registered">
            <span v-if="language=='fr-ca'">J'ai enregistré</span>
            <span v-else>I have registered</span>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
            <span v-if="language=='fr-ca'">Fermer</span>
            <span v-else>Dismiss</span>
        </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import BannerEN from './Register_2026/banner_en.png'
import BannerFR from './Register_2026/banner_fr.png'
import cache from '@/plugins/cache'
export default{
    created() {
        let info = cache.storage.local.get('register2026')
        if (!info) {
            this.showRegister = true
            cache.storage.local.set('register2026',{
                lastShown: new Date().toISOString(),
                nextShow: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7).toISOString(), // Show again in 7 days
                registered: false
            })
        }else{
            if(!info.registered && new Date(info.nextShow) < new Date()){
                this.showRegister = true
                cache.storage.local.set('register2026',{
                    lastShown: new Date().toISOString(),
                    nextShow: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7).toISOString(), // Show again in 7 days
                    registered: false
                })
            }
        }


    },
    props: {
        language: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showRegister: false,
        }
    },
    methods: {
        close() {
            this.showRegister = false;
        },
        registered() {
            this.showRegister = false;
            cache.storage.local.set('register2026',{
                lastShown: new Date().toISOString(),
                nextShow: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7).toISOString(), // Show again in 7 days
                registered: true
            })
        }
    },
    computed: {    
        banner() {
            return this.language === 'fr-ca' ? BannerFR : BannerEN
        }
    }
}
</script>

<style lang="scss" scoped>
.button-theme{
    min-width: 150px !important;
    background-color: $primary !important;
    color: white !important;
    font-weight: bold;
    // @media(max-width: 599px){
    //     width: 72px !important;
    // }
}

.red{
    background-color: $tc-red !important;
}
</style>